export const GUEST_CARD_REQUEST = 'GUEST_CARD_REQUEST';
export const GUEST_CARD_SUCCESS = 'GUEST_CARD_SUCCESS';
export const GUEST_CARD_FAILURE = 'GUEST_CARD_FAILURE';
